import { MapTo } from '@adobe/aem-react-editable-components';
import SearchBox from './SearchBox';
import { WithEmptyPlaceholder } from '../../../../lib/hoc/WithEmptyPlaceholder';
import { SearchBoxProps } from './Searchbox.types';

const RESOURCE_TYPE = 'learning-academy/components/custom/searchbox';

const SearchBoxEmptyFn = (props: SearchBoxProps) =>
  !props || props.ctaLabel === undefined || props.resultsPageLink === undefined;

const EditConfig = {
  emptyLabel: 'Search Box: Please configure the component',
  isEmpty: SearchBoxEmptyFn,
};

export default MapTo<SearchBoxProps>(RESOURCE_TYPE)(...WithEmptyPlaceholder(SearchBox, EditConfig));
